import type { ReactNode } from 'react';

export type BannerColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark';

export type IncidentBannerProps = {
  children?: ReactNode;
  type?: BannerColor;
  narrow?: boolean;
  cssClass?: string;
};

export function IncidentBanner({ children, type = 'dark', narrow = false, cssClass }: IncidentBannerProps) {
  const effectivePaddingClass = narrow ? 'px-2 py-1' : 'p-2';
  const effectiveBannerBackgroundClass = `bg-${type}`;
  const effectiveBannerTextColorClass = type !== 'light' ? 'text-white' : null;

  return (
    <div
      className={`${effectivePaddingClass} ${effectiveBannerBackgroundClass} ${effectiveBannerTextColorClass ?? ''} d-flex align-items-center justify-content-center ${cssClass ?? ''}`}
    >
      {children}
    </div>
  );
}
